import { cn } from '@opendoor/atoms/utils';
import { IconClock, IconKey } from '@tabler/icons-react';
import type { MarketplaceDisplayBadge } from '__generated__/zeus/types';
import {
  browseListingStatus,
  browseListingStatusLabel,
} from 'components/marketplace/helpers/browseListingStatus';
import { MAP_MARKER_COLORS } from 'components/marketplace/map/mapMarkerImage';

const BADGE_STYLES = {
  listed: { color: MAP_MARKER_COLORS.listed },
  'self-tour': { color: MAP_MARKER_COLORS.selfTour },
  'coming-soon': { color: MAP_MARKER_COLORS.comingSoonText },
};

export const ListingStatusBadge = ({ displayBadge }: { displayBadge: MarketplaceDisplayBadge }) => {
  const status = browseListingStatus(displayBadge);
  if (!status) {
    return null;
  }
  return (
    <span
      className={cn(
        'pointer-events-none inline-flex items-center gap-1 rounded-md px-2 py-1 text-[11px] font-medium leading-tight shadow-sm',
        status === 'coming-soon' && 'bg-[#f3ecfb]',
        status === 'self-tour' && 'bg-[#e4f3ed]',
        status === 'listed' && 'bg-white',
      )}
      style={BADGE_STYLES[status]}
    >
      {status === 'coming-soon' ? <IconClock size={12} aria-hidden /> : null}
      {status === 'self-tour' ? <IconKey size={13} aria-hidden /> : null}
      {status === 'listed' ? (
        <span className="size-1.5 rounded-full bg-current" aria-hidden />
      ) : null}
      {browseListingStatusLabel(displayBadge)}
    </span>
  );
};
